import { render, staticRenderFns } from "./InputVSelect.vue?vue&type=template&id=6415b358"
import script from "./InputVSelect.vue?vue&type=script&lang=js"
export * from "./InputVSelect.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports